import './App.css';
import LandingPage from './LandingPage/LandingPage';

function App() {
  return (
    <div className="App">
        <header className="App-header">
            <LandingPage />
        </header>
    </div>
  );
}

export default App;
